import React, { useRef, useEffect, useState } from 'react'
import { Card, Button, Row, Col, Input, Spin, Alert, Image } from 'antd'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
// import { CheckOutlined } from '@ant-design/icons'
import { readNfcUid, sendNfcSku, getTagTypeByUpc, apiTagValidation } from '@/services/tag/tag'
import { modalError, modalSuccess, modalConfirm } from '@/utils/modalUtils'
import { clearAuthentication, redirectURL } from '@/utils/authHelp'
import { handleChange, formatMessageNew, addZero, base64Url } from '@/utils/common'
let instance1 = null
let instance2 = null
let instance4 = null
let sendErr = {}
let errorNumRef = 0
let intervalRef = null
let interFlag = false
let lastSendData = {}
const TagPage = () => {
  const [tagTypeDataList, setTagTypeDataList] = useState([])

  const inputRef = useRef(null)
  const history = useHistory()
  const [intervalFlag, setIntervalFlag] = useState(false)
  const [isBlur, setIsBlur] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const [nfcValue, setNfcValue] = useState('')
  const [requiredTagType, setRequiredTagType] = useState('')
  const [actualTagTypeObj, setActualTagTypeObj] = useState({
    tagType: ''
  })
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [themeObj] = useState({ width: 500 * deviceSize, padding: 16 * deviceSize })
  const [imgObj] = useState({ width: 140 * deviceSize })
  const languageState = useSelector(state => state.commonStore.language)
  const workstationState = useSelector(state => state.commonStore.workstation)
  const macState = useSelector(state => state.commonStore.mac)
  useEffect(() => {
    // 防止切换语言后重复NFC报错不切换
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    // 启用定时器
    setIntervalFlag(!interFlag)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])
  useEffect(() => {
    inputRef.current.focus({
      cursor: 'all'
    })
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
      // 关闭定时器
      clearInterval(intervalRef)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onKeyDownBtn = e => {
    switch (e.keyCode) {
      case 13:
        if (instance1) {
          instance1.destroy()
          instance1 = null
          errorNumRef = 0
          if (sendErr.errorCode === '401') {
            clearAuthentication()
            window.location.href = redirectURL
          }
          sendErr = {}
          clearDataFun()
        }
        if (instance2) {
          instance2.destroy()
          instance2 = null
          errorNumRef = 0
          if (sendErr.errorCode === '401') {
            clearAuthentication()
            window.location.href = redirectURL
          }
          sendErr = {}
          setIntervalFlag(!interFlag)
        }
        if (instance4) {
          instance4.destroy()
          instance4 = null
          clearDataFun()
        }
        break
      default:
        break
    }
  }
  const onKeyDownCpu = e => {
    switch (e.keyCode) {
      case 13:
        getTagTypeFun()
        break
      default:
        break
    }
  }
  const onKeyDown = e => {
    switch (e.keyCode) {
      case 13:
        // sendNfcAndSku()
        apiTagValidationFun()
        break
      default:
        break
    }
  }
  useEffect(() => {
    if (upcValue.length === 0) {
      setRequiredTagType('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upcValue])

  const getTagTypeFun = () => {
    if (!upcValue) {
      return
    }
    let params = {
      upc: upcValue
    }
    getTagTypeByUpc(params)
      .then(res => {
        if (res.errorCode === '200') {
          setRequiredTagType(res.resultData?.tagType || '')
          if (res.resultData && res.resultData.tagPicBase64Str) {
            let imgLs = res.resultData.tagPicBase64Str.split(',')
            setTagTypeDataList(imgLs)
          }
          sendNfcAndSku()
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  const sendNfcAndSku = () => {
    if (upcValue && nfcValue) {
      if (lastSendData.upc === upcValue && lastSendData.nfcUid === nfcValue) {
        // 同一upc和nfc已经发送，防止重复发送
        return
      }
      lastSendData = {
        upc: upcValue,
        nfcUid: nfcValue
      }
      // if (tagTypeCheck()) return
      // 发送前关闭定时器
      clearInterval(intervalRef)
      let params = {
        upc: upcValue,
        nfcUid: nfcValue,
        actualTagType: actualTagTypeObj.tagType
        // "productCode": "string",
        // "productSize": "string",
        // requiredTagType: requiredTagType
      }
      setSpinLoading(true)
      sendNfcSku(params)
        .then(res => {
          setSpinLoading(false)
          instance4 = modalSuccess(
            {
              content: formatMessageNew('languageObj.commonLocale.tagSuccess')
            },
            () => {
              instance4 = null
              clearDataFun()
            }
          )
        })
        .catch(error => {
          setSpinLoading(false)
          sendErr = error
          if (errorNumRef === 0) {
            errorNumRef = 1
            let str = ''
            if (error.errorCode) {
              if (error.errorCode === '416') {
                str = formatMessageNew('languageObj.nsptagLocale.uidEmptyError')
              } else if (error.errorCode === '417') {
                str = formatMessageNew('languageObj.nsptagLocale.uidExistsError')
              } else if (error.errorCode === '418') {
                str = formatMessageNew('languageObj.nsptagLocale.upcEmptyError')
              } else if (error.errorCode === '419') {
                str = formatMessageNew('languageObj.nsptagLocale.skuNotExistError')
              } else if (error.errorCode === '422') {
                str = formatMessageNew('languageObj.nsptagLocale.nfcHasBoundError')
              } else if (error.errorCode === '401') {
                str = formatMessageNew('languageObj.commonLocale.tokenInvalid')
              } else if (error.errorCode === '435' || error.errorCode === '415') {
                str = formatMessageNew('languageObj.nsptagLocale.illegalUpcError')
              } else if (error.errorCode === '439') {
                str = formatMessageNew('languageObj.nsptagLocale.workstationError')
              } else if (error.errorCode === '442') {
                str = formatMessageNew('languageObj.nsptagLocale.NFCUIDDisabled')
              } else if (error.errorCode === '905') {
                str = `${formatMessageNew('languageObj.nsptagLocale.tagTypeNotMatch')} '${
                  error.resultData.requiredTagType
                }'`
              } else {
                str = formatMessageNew('languageObj.httpLocale.requestError')
              }
            } else {
              str = formatMessageNew('languageObj.httpLocale.requestError')
            }
            instance1 = modalError(
              {
                content: str
              },
              () => {
                sendErr = {}
                errorNumRef = 0
                instance1 = null
                clearDataFun()
                if (error.errorCode === '401') {
                  clearAuthentication()
                  window.location.href = redirectURL
                }
              }
            )
          }
        })
        .finally(() => {
          lastSendData = {}
        })
    }
  }

  const apiTagValidationFun = () => {
    if (!nfcValue) {
      return
    }
    apiTagValidation({ tagUid: nfcValue })
      .then(res => {
        if (res.errorCode === '200') {
          sendNfcAndSku()
        }
      })
      .catch(error => {
        // 关闭定时器
        clearInterval(intervalRef)
        sendErr = error
        if (errorNumRef === 0) {
          errorNumRef = 1
          if (error.errorCode === '421') {
            instance1 = modalError(
              {
                content: formatMessageNew('languageObj.nsptagLocale.NFCUIDInvalid')
              },
              () => {
                errorNumRef = 0
                sendErr = {}
                instance1 = null
                setNfcValue('')
                setActualTagTypeObj({
                  tagType: ''
                })
                // 启用定时器
                setIntervalFlag(!interFlag)
              }
            )
          }
          if (error.errorCode === '442') {
            instance2 = modalError(
              {
                content: formatMessageNew('languageObj.nsptagLocale.NFCUIDDisabled')
              },
              () => {
                errorNumRef = 0
                sendErr = {}
                instance2 = null
                setNfcValue('')
                setActualTagTypeObj({
                  tagType: ''
                })
                // 启用定时器
                setIntervalFlag(!interFlag)
              }
            )
          }
          if (error.errorCode === '401') {
            instance2 = modalError(
              {
                content: formatMessageNew('languageObj.commonLocale.tokenInvalid')
              },
              () => {
                instance2 = null
                errorNumRef = 0
                sendErr = {}
                clearAuthentication()
                window.location.href = redirectURL
              }
            )
          }
        }
      })
  }

  useEffect(() => {
    if (nfcValue?.length !== 0) {
      apiTagValidationFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nfcValue])
  useEffect(() => {
    if (!macState) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.macError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    if (!workstationState) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.workstationError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    interFlag = intervalFlag
    getNfcByTimes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalFlag])

  const getNfcByTimes = () => {
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    intervalRef = setInterval(() => {
      fetNFCFun()
    }, 1400)
  }
  const fetNFCFun = () => {
    // const params = {
    //   Connector: {
    //     ConnStr: 'RDType=RD5200;CommType=USB;AddrMode=0;SerNum='
    //   },
    //   OperatorName: 'InventoryOperator',
    //   InventoryOperator: {
    //     bHF: 1,
    //     Ant: [1],
    //     bISO14443A: false,
    //     bISO15693: true,
    //     bISO14443B: false
    //   }
    // }
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    readNfcUid({})
      .then(response => {
        let res = response.resultData
        if (response.errorcode === '200') {
          if (res && res.length > 0) {
            if (res.length > 1) {
              resetTagTypeValue()
              clearInterval(intervalRef)
              if (errorNumRef === 0) {
                errorNumRef = 1
                instance2 = modalError(
                  {
                    content: formatMessageNew('languageObj.nsptagLocale.multipleNfcError')
                  },
                  () => {
                    errorNumRef = 0
                    instance2 = null
                    // try {
                    //   // 发送前关闭定时器
                    //   clearInterval(intervalRef)
                    // } catch (error) {}
                    // 启用定时器
                    setIntervalFlag(!interFlag)
                  }
                )
              }
            } else {
              if (res[0].tagType && res[0].tagType.length > 0) {
                var str = res[0].tagType
                let result = ''
                if (str && str !== 'null') {
                  for (let i = 0; i < str.length; i += 2) {
                    let strcode = String.fromCharCode(parseInt(str.slice(i, i + 2), 16))
                    result += strcode
                  }
                }
                setActualTagTypeObj({
                  tagType: result,
                  version: ''
                })
              } else {
                setActualTagTypeObj({
                  tagType: '',
                  version: ''
                })
              }
              setNfcValue(res[0].UID)
              // 启用定时器
              setIntervalFlag(!interFlag)
            }
          } else {
            // 启用定时器
            setIntervalFlag(!interFlag)
            resetTagTypeValue()
          }
        } else {
          resetTagTypeValue()
          // clearInterval(intervalRef)
          if (errorNumRef === 0) {
            errorNumRef = 1
            modalConfirm(
              {
                content: formatMessageNew('languageObj.nsptagLocale.macError'),
                cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
                okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
                onCancel: () => {
                  errorNumRef = 0
                  history.goBack()
                }
              },
              () => {
                errorNumRef = 0
                clearAuthentication()
                history.push('/login')
              }
            )
          }
        }
      })
      .catch(error => {
        // clearInterval(intervalRef)
        if (errorNumRef === 0) {
          errorNumRef = 1
          modalConfirm(
            {
              content: formatMessageNew('languageObj.nsptagLocale.macError'),
              cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
              okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
              onCancel: () => {
                errorNumRef = 0
                history.goBack()
              }
            },
            () => {
              errorNumRef = 0
              clearAuthentication()
              history.push('/login')
            }
          )
        }
      })
  }
  const clearDataFun = () => {
    if (intervalRef) {
      clearInterval(intervalRef)
    }
    // 清空图片
    setTagTypeDataList([])
    setUpcValue('')
    setNfcValue('')
    setActualTagTypeObj({
      tagType: ''
    })
    inputRef.current.focus({
      cursor: 'all'
    })
    // 启用定时器
    setIntervalFlag(!interFlag)
  }
  const resetValues = () => {
    lastSendData = {}
    setRequiredTagType('')
    clearDataFun()
  }
  const resetTagTypeValue = () => {
    setNfcValue('')
    setActualTagTypeObj({
      tagType: ''
    })
  }
  const onFocusFun = e => {
    setIsBlur(false)
  }
  const onBlurFun = e => {
    setIsBlur(true)
  }
  const showError = () => {
    return isBlur && !upcValue && !instance1 && !instance2 && !instance4
  }
  return (
    <div>
      <div className="tag-container mt20" style={{ height: 'auto' }}>
        <Spin spinning={spinLoading} size="large">
          <Card
            style={{
              ...themeObj
            }}
            className="nfc_card"
          >
            {showError() ? (
              <Row type="flex" justify="center">
                <Col span={24}>
                  <div className="displayFlex">
                    <div style={{ width: '100px' }}></div>
                    <div className="mb15" style={{ flex: 1, height: 50 }}>
                      <Alert type="error" message={formatMessageNew('languageObj.nsptagLocale.blurTip')} banner />
                    </div>
                  </div>
                </Col>
              </Row>
            ) : (
              <div style={{ height: 50 }} className="mb15"></div>
            )}
            <Row>
              <Col
                style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                span={24}
              >
                <div style={{ width: '120px', textAlign: 'left' }}>UPC：</div>
                <Input
                  value={upcValue}
                  ref={inputRef}
                  onChange={e =>
                    handleChange(e, {
                      setState: value => {
                        const newValue = value ? addZero(value, 14) : value
                        setUpcValue(newValue)
                      }
                    })
                  }
                  placeholder={formatMessageNew('languageObj.nsptagLocale.pleaseScan') + 'UPC'}
                  allowClear
                  onKeyUp={e => onKeyDownCpu(e)}
                  onBlur={e => onBlurFun(e)}
                  onFocus={e => onFocusFun(e)}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ marginTop: '10px' }}>
                <div className="displayFlex">
                  <div>{formatMessageNew('languageObj.pftag.requiredTagType')}:</div>
                  <div className="pl5">
                    {requiredTagType &&
                      requiredTagType.split(',').map((item, idx) => {
                        return (
                          <div key={idx} className="displayFlex alignCenter mr10 mb10">
                            <span style={{ color: 'rgb(22, 119, 255)' }}>{item}</span>
                            {tagTypeDataList[idx] ? (
                              <>
                                <span className="splitSpan">-</span>
                                <Image
                                  rootClassName="imgReviewWrapper"
                                  width={imgObj.width}
                                  height={imgObj.width / 3.6}
                                  src={base64Url(tagTypeDataList[idx])}
                                />
                              </>
                            ) : null}
                          </div>
                        )
                      })}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt15">
              <Col
                style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                span={24}
              >
                <div style={{ width: '120px', textAlign: 'left' }}>NFC UID：</div>
                <Input
                  value={nfcValue}
                  onChange={e => handleChange(e, { setState: setNfcValue })}
                  placeholder={formatMessageNew('languageObj.nsptagLocale.pleaseScan') + 'NFC'}
                  allowClear
                  readOnly
                  onKeyUp={e => onKeyDown(e)}
                />
              </Col>
              {/* <Col span={2}>
              <CheckOutlined />
            </Col> */}
            </Row>
            <Row>
              <Col span={24} style={{ marginTop: '10px' }}>
                {formatMessageNew('languageObj.pftag.actualTagType')}:{' '}
                <span style={{ color: 'rgb(22, 119, 255)' }}>{actualTagTypeObj.tagType}</span>
              </Col>
            </Row>
            <Row>
              <Col className="mt15" style={{ textAlign: 'center' }} span={24}>
                <Button type="primary" onClick={resetValues} style={{ width: 100 }}>
                  {formatMessageNew('languageObj.nsptagLocale.reset')}
                </Button>
              </Col>
            </Row>
          </Card>
        </Spin>
      </div>
    </div>
  )
}
export default TagPage
